var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMetricsRightSphere(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 748 748"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "26.123%",
    cy: "37.366%",
    fx: "26.123%",
    fy: "37.366%",
    r: "62.861%",
    id: "metrics-right-sphere_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495D78",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101A2C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-27.8%",
    y: "-26.4%",
    width: "155.6%",
    height: "155.6%",
    filterUnits: "objectBoundingBox",
    id: "metrics-right-sphere_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.725490196 0 0 0 0 0.894117647 0 0 0 0 0.890196078 0 0 0 0.234320367 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "metrics-right-sphere_svg__b",
    cx: 1023,
    cy: 3008,
    r: 277
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-649 -2642)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#metrics-right-sphere_svg__a)",
    xlinkHref: "#metrics-right-sphere_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#metrics-right-sphere_svg__c)",
    xlinkHref: "#metrics-right-sphere_svg__b"
  }))));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNzQ4cHgiIGhlaWdodD0iNzQ4cHgiIHZpZXdCb3g9IjAgMCA3NDggNzQ4IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPHRpdGxlPk92YWwgQ29weSA3PC90aXRsZT4KICAgIDxkZWZzPgogICAgICAgIDxyYWRpYWxHcmFkaWVudCBjeD0iMjYuMTIyNTg3MSUiIGN5PSIzNy4zNjYxMTM1JSIgZng9IjI2LjEyMjU4NzElIiBmeT0iMzcuMzY2MTEzNSUiIHI9IjYyLjg2MDgyMjklIiBpZD0icmFkaWFsR3JhZGllbnQtMSI+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiM0OTVENzgiIG9mZnNldD0iMCUiPjwvc3RvcD4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iIzEwMUEyQyIgb2Zmc2V0PSIxMDAlIj48L3N0b3A+CiAgICAgICAgPC9yYWRpYWxHcmFkaWVudD4KICAgICAgICA8Y2lyY2xlIGlkPSJwYXRoLTIiIGN4PSIxMDIzIiBjeT0iMzAwOCIgcj0iMjc3Ij48L2NpcmNsZT4KICAgICAgICA8ZmlsdGVyIHg9Ii0yNy44JSIgeT0iLTI2LjQlIiB3aWR0aD0iMTU1LjYlIiBoZWlnaHQ9IjE1NS42JSIgZmlsdGVyVW5pdHM9Im9iamVjdEJvdW5kaW5nQm94IiBpZD0iZmlsdGVyLTMiPgogICAgICAgICAgICA8ZmVPZmZzZXQgZHg9IjAiIGR5PSI4IiBpbj0iU291cmNlQWxwaGEiIHJlc3VsdD0ic2hhZG93T2Zmc2V0T3V0ZXIxIj48L2ZlT2Zmc2V0PgogICAgICAgICAgICA8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSI1MCIgaW49InNoYWRvd09mZnNldE91dGVyMSIgcmVzdWx0PSJzaGFkb3dCbHVyT3V0ZXIxIj48L2ZlR2F1c3NpYW5CbHVyPgogICAgICAgICAgICA8ZmVDb2xvck1hdHJpeCB2YWx1ZXM9IjAgMCAwIDAgMC43MjU0OTAxOTYgICAwIDAgMCAwIDAuODk0MTE3NjQ3ICAgMCAwIDAgMCAwLjg5MDE5NjA3OCAgMCAwIDAgMC4yMzQzMjAzNjcgMCIgdHlwZT0ibWF0cml4IiBpbj0ic2hhZG93Qmx1ck91dGVyMSI+PC9mZUNvbG9yTWF0cml4PgogICAgICAgIDwvZmlsdGVyPgogICAgPC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9Ik92YWwtQ29weS03IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNjQ5LjAwMDAwMCwgLTI2NDIuMDAwMDAwKSI+CiAgICAgICAgICAgIDx1c2UgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMSIgZmlsdGVyPSJ1cmwoI2ZpbHRlci0zKSIgeGxpbms6aHJlZj0iI3BhdGgtMiI+PC91c2U+CiAgICAgICAgICAgIDx1c2UgZmlsbD0idXJsKCNyYWRpYWxHcmFkaWVudC0xKSIgZmlsbC1ydWxlPSJldmVub2RkIiB4bGluazpocmVmPSIjcGF0aC0yIj48L3VzZT4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==";
export { SvgMetricsRightSphere as ReactComponent };